<style lang="less" scoped>
  .login-container {
    width: 100%;
    height: 100%;
  }
  .section-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 486px;
    height: 100%;
    margin: 0 auto;
  }
  .logo {
    width: 239px;
    height: 111px;
    background-image: url(~@/assets/icon-bi.png);
    background-size: cover;
    background-repeat: no-repeat;
  }
  .document-group {
    display: flex;
    width: 100%;
    margin-top: 106px;
  }
  .document-button {
    display: flex;
    align-items: flex-end;
    flex: 1;
    height: 90px;
    padding-bottom: 9px;
    background-image: url(~@/assets/icon-docu-download.png);
    background-size: 30px;
    background-repeat: no-repeat;
    background-position: center 19px;
    text-decoration: none;
  }
  .document-button-text {
    width: 100%;
    margin-top: 18px;
    font-size: 14px;
    color: #303030;
    text-align: center;
  }
</style>

<template lang="pug">
  .login-container
    section.section-content
      h1.logo
      login-form(
        :currentTab="currentTab",
        :visible="visible",
        :searchedUsername="searchedUsername",
        :sentEmail="sentEmail",
        @login="login",
        @openDialog="openDialog",
        @closeDialog="closeDialog",
        @changeTab="changeTab",
        @goToRegist="goToRegist",
        @searchUsername="searchUsername",
        @findPassword="findPassword")
      .document-group
        a.document-button(download="회사 소개서 다운로드", href="/file/sta1_profile.pdf")
          p.document-button-text 회사 소개서 다운로드
</template>

<script>
import { mapState } from 'vuex';
import LoginForm from '@/components/LoginForm.vue';

export default {
  name: 'login',
  components: {
    LoginForm,
  },
  computed: {
    ...mapState({
      query: state => state.route.query,
    }),
  },
  beforeRouteEnter(to, from, next) {
    if (to.query.login !== undefined) {
      localStorage.setItem('token', to.query.login);
      window.location.href = '/';
    } else if (localStorage.token !== undefined) {
      return next('/');
    }
    return next();
  },
  data() {
    return {
      currentTab: 'username', // 'username', 'password'
      visible: false,
      searchedUsername: null,
      sentEmail: null,
    };
  },
  methods: {
    async login({ username, password }) {
      // TODO: login API. request body에 유저 데이터 store에 저장. token은 loalstorage 저장
      try {
        const login = await this.$http.post('/api/mkc/v1/login', { id: username, passwd: password });
        const { token } = login.data;
        this.$localStorage.set('token', token);
        this.$http.defaults.headers.common['mk-sess'] = token;
        await this.$store.dispatch('fetchMe');
        this.$router.replace('/');
      } catch (e) {
        this.$alert(e.response.data.message, {
          confirmButtonText: '확인',
        });
      }
    },
    openDialog(tabName) {
      this.visible = true;
      this.currentTab = tabName;
    },
    closeDialog() {
      this.visible = false;
      this.currentTab = 'username';
      this.searchedUsername = null;
      this.sentEmail = null;
    },
    changeTab(tabName) {
      this.currentTab = tabName;
      this.searchedUsername = null;
      this.sentEmail = null;
    },
    goToRegist() {
      this.$router.push('/register/terms');
    },
    async searchUsername(businessNumber) {
      try {
        const find = await this.$http.get('/api/mkc/v1/find-id', {
          params: {
            companyNumber: businessNumber.replace(/-/g, ''),
          },
        });
        this.searchedUsername = find.data.id;
      } catch (e) {
        this.$alert(e.response.data.message, {
          confirmButtonText: '확인',
        });
      }
    },
    async findPassword({ businessNumber, username }) {
      try {
        const find = await this.$http.get('/api/mkc/v1/reset-passwd', {
          params: {
            id: username,
            companyNumber: businessNumber.replace(/-/g, ''),
          },
        });
        this.sentEmail = find.data.email;
      } catch (e) {
        this.$alert(e.response.data.message, {
          confirmButtonText: '확인',
        });
      }
    },
  },
};
</script>
